import { render } from "./DraggableNestedList.vue?vue&type=template&id=70dcc999&scoped=true"
import script from "./DraggableNestedList.vue?vue&type=script&lang=js"
export * from "./DraggableNestedList.vue?vue&type=script&lang=js"

import "./DraggableNestedList.vue?vue&type=style&index=0&id=70dcc999&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dcc999"]])

export default __exports__